import axios from 'axios';
import Globals from '../Globals';
import { getLogModel } from '../Functions';
import LoggingService from './LoggingService';

const {
    ERROR_LOG_ID,
    ERROR_CODE,
    BFF_PATH: { BASE_URL, RENTING },
} = Globals;

class RentingService {
    constructor() {
        this.serviceUrl = axios.create({
            baseURL: BASE_URL + RENTING.BASE_PATH,
        });
    }

    methodName = async (body, token) => {
        const { config, data } = this.parseConfig(body, token); //get base config for request
        const response = await this.serviceUrl.post(/*methodEndpoint, data, config*/);
        return this.parseResponse(response); //parse JSONS
    };

    parseConfig = (body, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: ERROR_CODE,
            },
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: ERROR_CODE,
            },
            body: typeof body === 'string' ? body : JSON.stringify(body),
        };
        return { config, data };
    };

    parseResponse = response => {
        if (response?.data?.body) {
            const body = JSON.parse(response.data.body);
            if (body.Result) {
                body.Result = JSON.parse(body.Result);
            }
            response.data.body = body;
            return response.data;
        }

        return response;
    };

    /*

        RENTING RED RAC API CALLS

    */

    getFilters = async (body, token) => {
        const { config, data } = this.parseConfig(body, token);
        try {
            const response = await this.serviceUrl.post(
                RENTING.GET_FILTERS,
                data,
                config
            );

            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(
                ERROR_LOG_ID,
                error?.config?.url,
                config,
                data,
                error
            );
            new LoggingService().createLog(newError);
        }
    };

    getVehicles = async (body, token) => {
        const { config, data } = this.parseConfig(body, token);
        try {
            const response = await this.serviceUrl.post(
                RENTING.GET_VEHICLES,
                data,
                config
            );

            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(
                ERROR_LOG_ID,
                error?.config?.url,
                config,
                data,
                error
            );
            new LoggingService().createLog(newError);
        }
    };

    getVehiclePrices = async (body, token) => {
        const { config, data } = this.parseConfig(body, token);
        try {
            const response = await this.serviceUrl.post(
                RENTING.GET_VEHICLE_PRICES,
                data,
                config
            );

            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(
                ERROR_LOG_ID,
                error?.config?.url,
                config,
                data,
                error
            );
            new LoggingService().createLog(newError);
        }
    };

    getCustomer = async (body, token) => {
        const { config, data } = this.parseConfig(body, token);
        try {
            const response = await this.serviceUrl.post(
                RENTING.GET_CUSTOMER,
                data,
                config
            );

            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(
                ERROR_LOG_ID,
                error?.config?.url,
                config,
                data,
                error
            );
            new LoggingService().createLog(newError);
        }
    };

    buyVehicle = async (body, token) => {
        const { config, data } = this.parseConfig(body, token);
        try {
            const response = await this.serviceUrl.post(
                RENTING.BUY_VEHICLE,
                data,
                config
            );

            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(
                ERROR_LOG_ID,
                error?.config?.url,
                config,
                data,
                error
            );
            new LoggingService().createLog(newError);
        }
    };

    getPoblation = async (token, postalCode) => {
        const { config, data } = this.parseConfig(
            JSON.stringify(postalCode),
            token
        );

        try {
            const response = await this.serviceUrl.post(
                RENTING.GET_POBLATION,
                data,
                config
            );

            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(
                ERROR_LOG_ID,
                error?.config?.url,
                config,
                data,
                error
            );
            new LoggingService().createLog(newError);
        }
    };
}

const service = new RentingService();

export default service;
